var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 40,
    viewBox: "0 0 28 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.5006 23.7501H25.0005C23.8621 28.759 19.1028 32.5006 13.7507 32.5006C8.39777 32.5006 3.63847 28.759 2.50005 23.7501H0C1.10402 29.7486 6.32893 34.3879 12.5003 34.9439V37.5H11.2506C10.5602 37.5 10.0002 38.0608 10.0002 38.7504C10.0002 39.4416 10.5602 40 11.2506 40H16.2499C16.9403 40 17.5004 39.4416 17.5004 38.7504C17.5004 38.0608 16.9403 37.5 16.2499 37.5H15.0003V34.9439C21.1716 34.3879 26.3965 29.7486 27.5006 23.7501ZM13.7507 29.9998C18.5828 29.9998 22.5005 26.0829 22.5005 21.25V8.74978C22.5005 3.91688 18.5828 2.78238e-07 13.7507 2.78238e-07C8.91778 2.78238e-07 5.0001 3.91688 5.0001 8.74978V21.25C5.0001 26.0829 8.91778 29.9998 13.7507 29.9998ZM7.50015 8.74978C7.50015 5.29691 10.2986 2.50005 13.7507 2.50005C17.2019 2.50005 20.0004 5.29691 20.0004 8.74978V21.25C20.0004 24.7029 17.2019 27.4998 13.7507 27.4998C10.2986 27.4998 7.50015 24.7029 7.50015 21.25V8.74978Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.edcfecb327b09932dd0093bc84304c5f.svg";
export { ForwardRef as ReactComponent };